export const iconFontAwesomeArrowsDownload = (
	<i className="fa-solid fa-download"></i>
);
